<div class="main-container">

  <div class="title">
    <span class="title-text">Room Catalogue</span>
    <p class="small-title">The central location's inventory: premises, guest houses, rooms and their daily instances.</p>
  </div>

  <div class="ac-tabs">
    <button type="button" class="ac-tab" [class.active]="activeTab === 'premises'" (click)="setTab('premises')">Premises</button>
    <button type="button" class="ac-tab" [class.active]="activeTab === 'sets'" (click)="setTab('sets')">Guest houses</button>
    <button type="button" class="ac-tab" [class.active]="activeTab === 'rooms'" (click)="setTab('rooms')">Rooms</button>
    <button type="button" class="ac-tab" [class.active]="activeTab === 'instances'" (click)="setTab('instances')">Daily instances</button>
    <button type="button" class="ac-tab" [class.active]="activeTab === 'organisations'" (click)="setTab('organisations')">Organisations</button>
  </div>

  <div class="toolbar">
    @if(activeTab === 'sets'){
    <div class="filter-field">
      <span class="filter-label">Premises</span>
      <select class="text-box-active" [(ngModel)]="setsPremisesFilter" (change)="loadSets()">
        <option value="">All premises</option>
        @for(p of premises; track p.premisesId){ <option [value]="p.premisesId">{{ p.name }}</option> }
      </select>
    </div>
    <div class="filter-field">
      <span class="filter-label">Type</span>
      <select class="text-box-active" [(ngModel)]="setsTypeFilter" (change)="loadSets()">
        <option value="">All types</option>
        <option value="INTERNAL">Internal</option>
        <option value="EXTERNAL">External</option>
      </select>
    </div>
    }
    @if(activeTab === 'rooms'){
    <div class="filter-field">
      <span class="filter-label">Guest house</span>
      <select class="text-box-active" [(ngModel)]="roomsSetFilter" (change)="loadRooms()">
        <option value="">All guest houses</option>
        @for(s of allSets; track s.setId){ <option [value]="s.setId">{{ s.name }}</option> }
      </select>
    </div>
    }
    @if(activeTab === 'instances'){
    <div class="filter-field">
      <span class="filter-label">Date</span>
      <input type="date" class="text-box-active" [(ngModel)]="instanceDate" (change)="loadInstances()" />
    </div>
    }

    <input
      type="text"
      class="text-box-active search-input"
      placeholder="Search this list"
      [(ngModel)]="searchText"
    />

    @if(canManage && activeTab === 'organisations'){ <button type="button" class="ac-primary-btn add-btn" (click)="addOrganisation()">Add Organisation</button> }
    @if(canManage && activeTab === 'premises'){ <button type="button" class="ac-primary-btn add-btn" (click)="addPremises()">Add Premises</button> }
    @if(canManage && activeTab === 'sets'){ <button type="button" class="ac-primary-btn add-btn" (click)="addSet()">Add Guest House</button> }
    @if(canManage && activeTab === 'rooms'){ <button type="button" class="ac-primary-btn add-btn" (click)="addRoom()">Add Room</button> }
    @if(activeTab === 'instances' && canBlock){
    <button type="button" class="ac-secondary-btn add-btn" (click)="blockSelected('BLOCK')">Block selected</button>
    <button type="button" class="ac-secondary-btn add-btn" (click)="blockSelected('UNBLOCK')">Unblock selected</button>
    }
    @if(activeTab === 'instances' && canGenerate){
    <button type="button" class="ac-primary-btn add-btn" (click)="generate()">Generate next day</button>
    }
  </div>

  @if(activeTab === 'organisations'){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr><th>Name</th><th>Description</th><th>Address</th><th>Contact</th><th>Status</th>@if(canManage){<th>Actions</th>}</tr>
      </thead>
      <tbody class="table-body">
        @for(o of filteredOrganisations; track o.orgId){
        <tr>
          <td>{{ o.name }}</td>
          <td>{{ o.description }}</td>
          <td>{{ o.address }}</td>
          <td>{{ o.contactNumber }}</td>
          <td>{{ o.status }}</td>
          @if(canManage){
          <td class="actions-cell"><button type="button" class="ac-secondary-small-btn" (click)="editOrganisation(o)">Edit</button></td>
          }
        </tr>
        }
        @if(!isLoading && filteredOrganisations.length === 0){
        <tr><td [attr.colspan]="canManage ? 6 : 5" class="empty-row">No organisations found.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(activeTab === 'premises'){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr><th>Name</th><th>Short name</th><th>Organisation</th><th>Contact</th><th>Rank</th><th>Status</th>@if(canManage){<th>Actions</th>}</tr>
      </thead>
      <tbody class="table-body">
        @for(p of filteredPremises; track p.premisesId){
        <tr>
          <td>{{ p.name }}</td>
          <td>{{ p.abbrevName }}</td>
          <td>{{ p.orgName || '-' }}</td>
          <td>{{ p.contactNumber }}</td>
          <td>{{ p.distanceRank ?? '-' }}</td>
          <td>{{ p.status }}</td>
          @if(canManage){
          <td class="actions-cell"><button type="button" class="ac-secondary-small-btn" (click)="editPremises(p)">Edit</button></td>
          }
        </tr>
        }
        @if(!isLoading && filteredPremises.length === 0){
        <tr><td [attr.colspan]="canManage ? 7 : 6" class="empty-row">No premises found.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(activeTab === 'sets'){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr><th>Name</th><th>Premises</th><th>Type</th><th>Category</th><th>Floors</th><th>Capacity</th><th>Status</th>@if(canManage){<th>Actions</th>}</tr>
      </thead>
      <tbody class="table-body">
        @for(s of filteredSets; track s.setId){
        <tr>
          <td>{{ s.name }}</td>
          <td>{{ s.premisesName || '-' }}</td>
          <td>{{ s.type }}</td>
          <td>{{ s.category }}</td>
          <td>{{ s.floorCount }}</td>
          <td>{{ s.totalCapacity ?? '-' }}</td>
          <td>{{ s.status }}</td>
          @if(canManage){
          <td class="actions-cell">
            <button type="button" class="ac-secondary-small-btn" (click)="editSet(s)">Edit</button>
            <button type="button" class="ac-secondary-small-btn" (click)="changeSetState(s)">
              {{ s.status === 'ACTIVE' ? 'Deactivate' : 'Activate' }}
            </button>
          </td>
          }
        </tr>
        }
        @if(!isLoading && filteredSets.length === 0){
        <tr><td [attr.colspan]="canManage ? 8 : 7" class="empty-row">No guest houses found.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(activeTab === 'rooms'){
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr><th>Room</th><th>Guest house</th><th>Category</th><th>Floor</th><th>Beds</th><th>Capacity</th><th>Regular</th><th>Utsav</th><th>Status</th>@if(canManage){<th>Actions</th>}</tr>
      </thead>
      <tbody class="table-body">
        @for(r of filteredRooms; track r.accommodationId){
        <tr>
          <td>{{ r.accommodationNumber }} · {{ r.abbrevName }}</td>
          <td>{{ r.setName || '-' }}</td>
          <td>{{ r.category }}</td>
          <td>{{ r.floorNumber }}</td>
          <td>{{ r.bedCount }}</td>
          <td>{{ r.totalCapacity }}</td>
          <td>{{ r.regularFlag ? 'Yes' : 'No' }}{{ r.regularAutoAllocFlag ? ' · auto' : '' }}</td>
          <td>{{ r.utsavFlag ? 'Yes' : 'No' }}{{ r.utsavAutoAllocFlag ? ' · auto' : '' }}</td>
          <td>{{ r.status }}</td>
          @if(canManage){
          <td class="actions-cell">
            <button type="button" class="ac-secondary-small-btn" (click)="editRoom(r)">Edit</button>
            <button type="button" class="ac-secondary-small-btn" (click)="changeRoomState(r)">
              {{ r.status === 'ACTIVE' ? 'Deactivate' : 'Activate' }}
            </button>
          </td>
          }
        </tr>
        }
        @if(!isLoading && filteredRooms.length === 0){
        <tr><td [attr.colspan]="canManage ? 10 : 9" class="empty-row">No rooms found.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

  @if(activeTab === 'instances'){
  <p class="hint-note">New or changed inventory shows up here only for dates generated after the change.</p>
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>@if(canBlock){<th></th>}<th>Guest house</th><th>Room</th><th>Type</th><th>Floor</th><th>Capacity</th><th>Status</th><th>Reason</th></tr>
      </thead>
      <tbody class="table-body">
        @for(i of filteredInstances; track instanceKey(i)){
        <tr>
          @if(canBlock){
          <td class="check-cell">
            <input type="checkbox" [checked]="isInstanceSelected(i)" (change)="toggleInstance(i)" />
          </td>
          }
          <td>{{ i.guestHouse }}</td>
          <td>{{ i.roomCode }}</td>
          <td>{{ i.accommoType }}</td>
          <td>{{ i.floorNumber }}</td>
          <td>{{ i.availableCapacity }} / {{ i.totalCapacity }}</td>
          <td>{{ i.status || 'FREE' }}</td>
          <td>{{ i.reason || '-' }}</td>
        </tr>
        }
        @if(!isLoading && filteredInstances.length === 0){
        <tr><td [attr.colspan]="canBlock ? 8 : 7" class="empty-row">No instances for this date.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
